import React from "react";
import i18n from "@/utils/i18n";
import { useTranslation } from "react-i18next";
import {
  TextType,
  DropdownList,
  RadioButton,
  CheckboxSquare,
  StarRating,
  ScaleRating,
  MatrixTable,
} from "@/components/icons";
import styles from "./QuestionTypeSelector.module.scss";

export type QuestionType =
  | "text"
  | "dropdown"
  | "single_choice"
  | "multiple_choice"
  | "star_rating"
  | "scale"
  | "matrix";

interface QuestionTypeOption {
  type: QuestionType;
  labelKey: string;
  defaultLabel: string;
  icon: React.FC<React.SVGProps<SVGSVGElement>>;
}

const QUESTION_TYPES: QuestionTypeOption[] = [
  {
    type: "text",
    labelKey: "createPoll.questionTypes.text",
    defaultLabel: "Metin",
    icon: TextType,
  },
  {
    type: "dropdown",
    labelKey: "createPoll.questionTypes.dropdown",
    defaultLabel: i18n.t("questionTypes.dropdown"),
    icon: DropdownList,
  },
  {
    type: "single_choice",
    labelKey: "createPoll.questionTypes.singleChoice",
    defaultLabel: i18n.t("questionTypes.singleChoice"),
    icon: RadioButton,
  },
  {
    type: "multiple_choice",
    labelKey: "createPoll.questionTypes.multipleChoice",
    defaultLabel: i18n.t("questionTypes.multipleChoice"),
    icon: CheckboxSquare,
  },
  {
    type: "star_rating",
    labelKey: "createPoll.questionTypes.starRating",
    defaultLabel: i18n.t("questionTypes.starRating"),
    icon: StarRating,
  },
  {
    type: "scale",
    labelKey: "createPoll.questionTypes.scale",
    defaultLabel: i18n.t("questionTypes.scale"),
    icon: ScaleRating,
  },
  {
    type: "matrix",
    labelKey: "createPoll.questionTypes.matrix",
    defaultLabel: "Tablo Soru",
    icon: MatrixTable,
  },
];

interface QuestionTypeSelectorProps {
  onSelectType: (type: QuestionType) => void;
  className?: string;
}

const QuestionTypeSelector: React.FC<QuestionTypeSelectorProps> = ({
  onSelectType,
  className = "",
}) => {
  const { t } = useTranslation();

  return (
    <div className={`${styles.container} ${className}`}>
      {QUESTION_TYPES.map((option) => {
        const Icon = option.icon;
        return (
          <button
            key={option.type}
            type="button"
            className={styles.typeButton}
            onClick={() => onSelectType(option.type)}
          >
            <Icon width={24} height={24} />
            <span className={styles.typeLabel}>
              {t(option.labelKey, option.defaultLabel)}
            </span>
          </button>
        );
      })}
    </div>
  );
};

export default QuestionTypeSelector;
export { QUESTION_TYPES };
